import React from 'react';
import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { isOverdue } from './mbApi';
import { STAGE_LABEL } from './HandoffControl';

export const NO_FILTER = { q: '', stage: 'all', pic: 'all', deadline: 'all' };

export const applyFilters = (list, f) => list.filter((w) => (
  (!f.q || `${w.code || ''} ${w.title}`.toLowerCase().includes(f.q.trim().toLowerCase()))
  && (f.stage === 'all' || (w.current_stage || 'brief') === f.stage)
  && (f.pic === 'all' || w.current_pic_id === f.pic)
  && (f.deadline === 'all' || (f.deadline === 'overdue' ? isOverdue(w) : f.deadline === 'none' ? !w.deadline : !!w.deadline))
));

export const Pick = ({ id, value, onChange, label, options }) => (
  <Select value={value} onValueChange={onChange}>
    <SelectTrigger className="h-10 w-full sm:w-44" aria-label={label} data-testid={id}><SelectValue /></SelectTrigger>
    <SelectContent>{options.map(([k, v]) => <SelectItem key={k} value={k}>{v}</SelectItem>)}</SelectContent>
  </Select>
);

export const TaskFilters = ({ f, setF, members }) => {
  const set = (k) => (v) => setF({ ...f, [k]: v });
  return (
    <div className="grid grid-cols-1 sm:flex sm:flex-wrap gap-2" data-testid="mb-task-filters">
      <Input value={f.q} onChange={(e) => set('q')(e.target.value)} placeholder="Cari kod / tajuk brief" aria-label="Cari tugasan" className="h-10 sm:w-56" data-testid="mb-filter-q" />
      <Pick id="mb-filter-stage" label="Tapis tahap" value={f.stage} onChange={set('stage')} options={[['all', 'Semua tahap'], ...Object.entries(STAGE_LABEL)]} />
      <Pick id="mb-filter-pic" label="Tapis PIC" value={f.pic} onChange={set('pic')} options={[['all', 'Semua PIC'], ...members.map((m) => [m.id, m.name])]} />
      <Pick id="mb-filter-deadline" label="Tapis deadline" value={f.deadline} onChange={set('deadline')}
        options={[['all', 'Semua deadline'], ['overdue', 'Lewat deadline'], ['has', 'Ada deadline'], ['none', 'Tiada deadline']]} />
    </div>
  );
};
